<template>
    <v-card outlined style="border:none">
        <div>
            <v-card-title
                class="subtitle-3 d-flex"
                style="word-break: normal; justify-content: space-evenly; flex-wrap: nowrap;"
            >
                <v-btn
                    class="text-capitalize"
                    depressed
                    elevation="8"
                    fab
                    dark
                    @click="goToPrevStep()"
                >
                    <v-icon size="20" v-text="icons.mdiArrowLeft"></v-icon>
                </v-btn>

                <span class="text-h4 pl-5 pr-5">{{
                    newCampaign.category && translations.fillTitleCampaign[lang]
                }}</span>

                <v-btn
                    class="text-capitalize"
                    depressed
                    :elevation="0"
                    dark
                    fab
                    :disabled="true"
                >
                    <v-icon size="20" v-text="icons.mdiArrowRight"></v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="text--primary pt-5">
                <v-row class="flex-column justify-center align-center">
                    <div
                        ref="conditions"
                        id="conditions"
                        style="min-height: 100px; max-width: 700px; width: 100%"
                    >
                        <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            class="d-flex flex-column"
                        >
                            <b-text-field
                                v-model="newCampaign.title"
                                :label="translations.titleCampaign[lang]"
                                :success="Boolean(newCampaign.title)"
                                :error-messages="errorTitle"
                                @focus="errorTitle = ''"
                                @blur="validateTitle"
                            >
                            </b-text-field>
                        </v-col>
                    </div>
                </v-row>
            </v-card-text>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
            <v-row class="flex-column justify-center align-center">
                <v-col cols="12" sm="12" md="12" class="d-flex flex-column">
                    <v-btn
                        color="secondary"
                        text
                        @click="createCampaign"
                        type="submit"
                        :loading="loading"
                        :disabled="disableBtn"
                    >
                        {{ translations.submitCampaign[lang] }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mdiArrowLeft } from "@mdi/js";
import { mapMutations, mapState, mapActions } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/campaigns/newCampaign";

export default {
    name: "Step7",

    mixins: [translations],

    data: () => ({
        icons: {
            mdiArrowLeft
        },
        errorTitle: "",
        errorTitleBlank: {
            el: "Ο τίτλος της καμπάνιας δεν μπορεί να είναι κενός",
            en: "Campaign title cannot be blank",
            it: "Il titolo della campagna non può essere vuoto"
        }
    }),

    computed: {
        // ...mapState("loyaltyPanel/campaigns/newCampaign", ["campaignTypes"]),
        ...mapState(["loading"]),

        lang() {
            return this.$route.params.lang;
        },

        newCampaign: {
            get() {
                return this.$store.state.loyaltyPanel.campaigns.newCampaign
                    .newCampaign;
            },
            set(val) {
                this.setNewCampaign(val);
            }
        },

        disableBtn() {
            return !this.newCampaign.title;
        }
    },

    methods: {
        ...mapActions("loyaltyPanel/campaigns/newCampaign", ["createCampaign"]),
        ...mapMutations("loyaltyPanel/campaigns/newCampaign", [
            "setStep"
        ]),
        validateTitle() {
            if (!this.newCampaign.title) {
                this.errorTitle = this.errorTitleBlank[this.lang];
            } else {
                this.errorTitle = "";
            }
        },
        goToPrevStep(){
            if(this.newCampaign.category == 'draw'){
                this.setStep(5)
            }else{
                this.$emit('prev')
            }
        }
    },

};
</script>

<style>
.no-messages .v-messages {
    display: none;
}
</style>

<style scoped>
.border-grey {
    border: 2px solid grey;
}

.b-outlined {
    border: 1px solid rgba(0, 0, 0, 0.12);
}

.icon-container {
    /* margin-top:20px; */
    height: 200px;
    width: 200px;
}
.select-category {
    cursor: pointer;
    transition: all 0.5s ease-out;
    background-color: white;
    min-width: 200px;
    font-size: 22px;
    color: gray;
    /* border: 1px solid black */
}
.select-category:hover {
    /* background-color: rgba(0, 0, 0, 0.2); */
    background-color: #27272730;
    color: black;
    border-color: black;
    /* font-size: 26px; */
}

.invisible {
    opacity: 0;
    z-index: 0;
}

.overlapped {
    position: absolute;
}

.transition-all {
    transition: all 1s, width 2s, max-width 1s, min-width 1s, margin-left 2s,
        margin-top 2.5s, background-position 1.5s, opacity 1s;
}
.back-button {
    position: absolute;
    top: 45%;
    z-index: 10;
}
.mw-100 {
    min-width: 100% !important;
}
.mw-180 {
    min-width: 180px !important;
}
.selected-condition {
    color: white;
    background: #272727;
    border-color: #272727;
}

.selected-condition .v-icon {
    background: white;
    color: #272727;
}
.selected-condition .border-grey {
    border-color: #272727;
}
</style>
